var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crisis-response-banner"},[_c('div',{staticClass:"crisis-response-banner__text",domProps:{"innerHTML":_vm._s(_vm.crisisResponseBanner)}})])}
var staticRenderFns = []

export { render, staticRenderFns }